import * as Control$dMonad$dExcept$dTrans from "../Control.Monad.Except.Trans/index.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dIdentity from "../Data.Identity/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMap$dSerialized from "../Data.Map.Serialized/index.js";
import * as Data$dNonEmpty from "../Data.NonEmpty/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dUUID from "../Data.UUID/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Restaumatic$dForm$dGenerateId from "../Restaumatic.Form.GenerateId/index.js";
const EntityId = x => x;
const ufromJSONKey = Data$dUUID.ufromJSONKeyUUID;
const udecodeEntityId = Data$dUUID.udecodeUUID;
const showEntityId = Data$dUUID.showUUID;
const ordEntityId = Data$dOrd.ordString;
const newtypeEntityId = {Coercible0: () => {}};
const genericEntityId = {to: x => x, from: x => x};
const generateEntityId = Restaumatic$dForm$dGenerateId.generateUUID;
const eqEntityId = Data$dEq.eqString;
const encodeEntityId = Data$dUUID.encodeUUID;
const decodeEntityId = Data$dUUID.decodeUUID;
const asJSONKeyEntityId = {
  asJSONKey: /* #__PURE__ */ Data$dMap$dSerialized.$AsJSONKeyFunction(
    "AsJSONKeyString",
    x => x,
    /* #__PURE__ */ (() => {
      const $0 = Control$dMonad$dExcept$dTrans.monadThrowExceptT(Data$dIdentity.monadIdentity).throwError(Data$dNonEmpty.$NonEmpty(
        Foreign.$ForeignError("ForeignError", "invalid UUID"),
        Data$dList$dTypes.Nil
      ));
      const $1 = Control$dMonad$dExcept$dTrans.applicativeExceptT(Data$dIdentity.monadIdentity).pure;
      return x => {
        if (Data$dUUID.isValidUUID(x)) { return $1(x); }
        return $0;
      };
    })()
  )
};
export {
  EntityId,
  asJSONKeyEntityId,
  decodeEntityId,
  encodeEntityId,
  eqEntityId,
  generateEntityId,
  genericEntityId,
  newtypeEntityId,
  ordEntityId,
  showEntityId,
  udecodeEntityId,
  ufromJSONKey
};
